import { createSelector } from "reselect"
import { get } from "lodash"
import { getQueryGroupBy } from "helpers/rollups"
import { getIsOpPro } from "modules/account-root/selectors"
import { createQueryStringSelector } from "selectors/queryString"
import { getBaseMetricTypeOptions } from "selectors/assets/metricTypes"
import { getContentSets, getSelectedViewIsContentSet, getSelectedContentSetCategories, getSelectedContentSetDataType } from "selectors/contentSets"
import { computeAssetViewMenuItems, computeSubViewOptions, computeSelectedMetricType, computeContentSetFactorsFromCategories, computeSelectedSubView, computeMetricTypeOptions, computeSort, computeColumnOrderOptions } from "helpers/assets"
import { getSelectedView } from "selectors/assets"
import { computeAttributionMethod } from "helpers/risk"
import { getDefaultMetricUnits } from "modules/default-metric-units/selectors"
import { getModelCategories } from "selectors/modelMetadata"

const DEFAULT_SORT = { id: "percentEquity", direction: "desc" }

export const getSelectedGroup = createQueryStringSelector("selectedGroup")
export const getSelectedMetricTypeId = createQueryStringSelector("metricType")
export const getRawSort = createQueryStringSelector("sort", DEFAULT_SORT)
export const getRawSelectedSubView = createQueryStringSelector("subView")
export const getColumnOrder = createQueryStringSelector("columnOrder", "default")
export const getGrouping = (_, props) => props.currentGrouping
export const getIsActive = (_, props) => props.isActive
export const getModelId = (_, props) => props.modelId
export const getAssetName = (_, props) => props.assetName
export const getViewType = (_, props) => props.viewType
export const getDisableColumnClick = (_, props) => get(props, "disableColumnClick", false)
export const getAssetType = (_, props) => props.assetType

export const getMenuItems = createSelector(
  [getIsOpPro, getContentSets],
  computeAssetViewMenuItems,
)

export const getGroupingOptions = createSelector(
  [getGrouping, getIsActive],
  getQueryGroupBy,
)

export const getIdSort = createSelector(
  [getRawSort],
  computeSort,
)

export const getMetricTypeOptions = createSelector(
  [getBaseMetricTypeOptions, getSelectedView, getSelectedViewIsContentSet, getAssetType, getSelectedContentSetDataType, getDefaultMetricUnits],
  computeMetricTypeOptions,
)

export const getSelectedMetricType = createSelector(
  [getSelectedMetricTypeId, getMetricTypeOptions],
  computeSelectedMetricType,
)

export const getSubViewOptions = createSelector(
  [getSelectedView, getSelectedContentSetCategories, getModelCategories, getSelectedViewIsContentSet],
  computeSubViewOptions,
)

export const getSelectedSubView = createSelector(
  [getRawSelectedSubView, getSubViewOptions],
  computeSelectedSubView,
)

export const getColumnOrderOptions = createSelector(
  [getSelectedView],
  computeColumnOrderOptions,
)

export const getContentSetCategoryFactors = createSelector(
  [getSelectedSubView, getSelectedContentSetCategories],
  computeContentSetFactorsFromCategories,
)

export const getAttributionMethod = createSelector(
  [getIsActive],
  computeAttributionMethod,
)
